const LOCAL_API_URL = "http://127.0.0.1:8000";
const LOCAL_MEDIA_URL = "http://127.0.0.1:8000";
const LOCAL_REDIRECT_URL = "http://localhost:3000";

const PRODUCTION_API_URL = "https://paduapp.gr";
const PRODUCTION_MEDIA_URL = "https://paduapp.gr";
const PRODUCTION_REDIRECT_URL = "https://paduapp.gr";

export const ACTIVE_URL = PRODUCTION_API_URL;
export const ACTIVE_MEDIA_URL = PRODUCTION_API_URL;
export const ACTIVE_REDIRECT_URL = PRODUCTION_API_URL;
